<!-- formulario de busqueda -->
<div [formGroup]="formBusqueda" class="mb-2 p-1 w-full border rounded border-solid border-gray-300
dark:border-gray-500 font-semibold text-base text-gray-500 dark:text-gray-200">
    <div class="w-full justify-start">
        <span class="font-bold">Busqueda Personalizada</span>
    </div>
    <br>
    <div class="grid grid-cols-4 gap-4 mt-2 justify-center">
        <div class="flex justify-center">
            <div class="mb-2">
                <span for="input" class="pl-2 block mb-1 text-sm">Fecha:</span>
                <input formControlName="fecha" type="date" class="block pl-3 text-xs font-semibold uppercase text-gray-500 bg-white dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"/>
            </div>
        </div>
        <div class="flex justify-center">
            <div class="mb-2">
                <label for="input" class="pl-2 block mb-1 text-sm">Clasificación de vehiculo:</label>
                <select formControlName="vehiculos" class="w-full appearance-none block ml-2 p-1 text-xs font-semibold uppercase text-gray-500 bg-white dark:text-gray-100 dark:bg-gray-700 bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
                    <option value="" selected>Selecciona el tipo vehiculo</option>
                    <option *ngFor="let vehiculo of tiposVehiculo" value="{{ vehiculo.id }}">{{ vehiculo.tipo }} - {{ vehiculo.clasificacion }}</option>
                </select>
            </div>
        </div>
        <div class="flex justify-center">
            <div class="mb-2">
                <label for="input" class="pl-2 block mb-1 text-sm">Carril:</label>
                <select formControlName="carriles" multiple size="1" id="countries_multiple" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option value="" selected>Seleccionar un carril</option>
                    <option  *ngFor="let carril of carriles" value="{{ carril.id }}">{{ carril.nombre }}</option>
                </select>
            </div>
        </div>
        <div class="text-center justify-center">    
            <button type="button" [disabled]="loadingIndicator" (click)="searchData()" class="bg-blue-600 inline-flex items-end  rounded p-2 text-xs font-semibold border-2 border-gray-300 drop-shadow-lg hover:border-blue-600 uppercase">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>  
                <span class="ml-2">Consultar</span>
            </button><br><br>
            <button *ngIf="rows != null" type="button" [disabled]="loadingIndicator" (click)="exportFileExcel()" class="mt-1 bg-blue-600 inline-flex items-end  rounded p-2 text-xs font-semibold border-2 border-gray-300 drop-shadow-lg hover:border-blue-600 uppercase">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17 4h-1V2H8v2H7c-1.11 0-2 .89-2 2v3H2v6h2v3c0 1.11.89 2 2 2h11c1.11 0 2-.89 2-2v-3h2v-6h-2V9c0-1.11-.89-2-2-2zm-7 0h4v3H7V4zm7 14H7v-5h4v2h6v-2h4v5zm2-8h-3V9h3v1z" />
                </svg>  
                <span class="ml-2">Exportar</span>
            </button>
        </div>
    </div>
</div>

<!-- Resultado de consulta ngx data table -->
<div class="mb-2 p-1 w-full border rounded border-solid border-gray-300 dark:border-gray-500
 font-semibold text-base text-gray-500 dark:text-gray-200">
   <div *ngIf="rows != null; else cargandoData">
    <ngx-datatable
        class="material"
        [rows]="rows.data"
        [columns]="colums"
        [columnMode]="ColumnMode.forceFit"
        [headerHeight]="50"
        [footerHeight]="50"
        [loadingIndicator]="loadingIndicator"
        rowHeight="auto"
        [scrollbarV]="true"
        [virtualization]="false"
        [externalPaging]="true"
        [count]="rows.total"
        [offset]="rows.current_page - 1"
        [limit]="rows.per_page"
        (page)="setPage($event)">
    <!-- colums -->
        <ngx-datatable-column name="FECHA CRUCE" prop="fecha">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value | date: 'dd/MM/YYYY' }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="CARRIL" prop="carril">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="TIPO VEHICULO" prop="vehiculo">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="TARIFA" prop="monto">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="CANTIDAD" prop="cantidad">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="SUBTOTAL" prop="subtotal">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{ value | currency }}
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
   </div>
    <ng-template class="text-center" #cargandoData>
        {{ loadingIndicator ? 'cargando información por favor espera ...' : 'selecciona la información y da click al botón consultar' }}
    </ng-template>
    <br>
    <div class="grid grid-cols-4 gap-1 mt-2">
        <div></div><div></div>
        <div class="pl-10 justify-end">
            <p class="text-sm text-right ">TOTAL DEL DIA:</p>
        </div>
        <div class="justify-end border rounded border-solid border-gray-300 dark:border-gray-500
        font-semibold text-base text-gray-500 dark:text-gray-200">
            <p class="text-center">{{ totalDineroCobrado | currency }}</p> 
        </div>
      </div>
</div>


